import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ClosingBinder from "./ClosingBinder";
import DraftPackage from "./DraftPackage";

/**
 * Combined print bundle for a borrower loan row: the SEUTRADE Closing Binder
 * followed by the completed Private Negotiable Instrument, stacked in ONE document so the
 * admin can Save-as-PDF (or Print) a single file containing both. Rendered in
 * the admin's own browser — no server-side headless Chrome required.
 *
 * Both child pages hydrate from /api/borrower/applications/:appId (the admin
 * session carries auth). Their on-screen toolbars carry `.no-print` and are
 * hidden by each page's own @media print rules, so only the paper documents
 * appear in the printed output.
 */
export default function PrintBundle() {
  const { appId } = useParams();
  const [sp] = useSearchParams();

  useEffect(() => {
    if (sp.get("auto") !== "1") return;
    // Give both child pages time to fetch + paint before opening the dialog.
    const t = setTimeout(() => window.print(), 2200);
    return () => clearTimeout(t);
  }, [sp]);

  return (
    <div data-testid="print-bundle" key={appId}>
      <ClosingBinder />
      <div className="bundle-page-break" style={{ breakBefore: "page", pageBreakBefore: "always" }} />
      <DraftPackage />
    </div>
  );
}
